// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__Auuz3","createdSearch":"index_createdSearch__VZhlH","custom_table":"index_custom_table__fNPeu"};